/* Gee Beauty US menu destination clicks. Uses the existing consent-managed pixel. */
(function () {
  'use strict';
  if (!/^(www\.)?geebeauty\.com$/.test(location.hostname) || window.__geeMenuTrackingV1) return;
  window.__geeMenuTrackingV1 = true;

  function label(node) {
    return node ? node.textContent.replace(/\s+/g, ' ').trim().toLowerCase().slice(0, 100) : '';
  }
  function childrenMatching(node, selector) {
    return Array.from(node.children).filter(function (child) { return child.matches(selector); });
  }
  function describe(anchor) {
    var mobile = anchor.closest('.mobileMenu__root');
    var desktop = anchor.closest('.header__primary');
    if (!anchor.closest('header.header') || (!mobile && !desktop)) return null;
    var root, item, top, title, level;
    if (mobile) {
      if (!anchor.matches('a.mobileMenu__button')) return null;
      root = mobile;
      item = anchor.closest('.mobileMenu__item');
      if (!item) return null;
      top = item;
      while (top.parentElement && top.parentElement !== root) top = top.parentElement;
      if (top.parentElement !== root || !top.matches('.mobileMenu__item')) return null;
      title = top.querySelector(':scope > .mobileMenu__button .mobileMenu__title');
      level = item === top ? 'primary' : 'submenu';
    } else {
      root = desktop;
      top = anchor.closest('.headerMenuItem');
      if (!top || top.parentElement !== root) return null;
      title = top.querySelector('.headerMenuItem__summary');
      level = anchor.matches('.headerMenuItem__directLink') ? 'primary' : 'submenu';
    }
    var siblings = childrenMatching(root, mobile ? '.mobileMenu__item' : '.headerMenuItem');
    var url;
    try { url = new URL(anchor.getAttribute('href'), location.href); } catch (_) { return null; }
    if (!/^https?:$/.test(url.protocol) || !anchor.getAttribute('href') || anchor.getAttribute('href').charAt(0) === '#') return null;
    var itemLabel = label(anchor.querySelector('.mobileMenu__title') || anchor);
    if (!itemLabel) return null;
    return {
      menu_label: itemLabel,
      menu_parent: label(title),
      menu_type: mobile ? 'mobile' : 'desktop',
      menu_level: level,
      menu_position: String(siblings.indexOf(top) + 1),
      destination_path: url.pathname.slice(0, 100),
      destination_domain: url.hostname,
      page_path: location.pathname,
      page_location: location.origin + location.pathname,
      market: 'us',
      store_domain: location.hostname,
      tracking_version: 'menu_v1',
      tracking_environment: window.Shopify && window.Shopify.theme && window.Shopify.theme.role === 'main' ? 'live' : 'preview'
    };
  }
  document.addEventListener('click', function (event) {
    if (!event.isTrusted || event.button !== 0) return;
    var node = event.target instanceof Element ? event.target : event.target.parentElement;
    var anchor = node && node.closest('a[href]');
    if (!anchor) return;
    var data = describe(anchor);
    if (!data || !window.Shopify || !window.Shopify.analytics || typeof window.Shopify.analytics.publish !== 'function') return;
    if (data.tracking_environment === 'preview') data.debug_mode = true;
    try {
      var result = window.Shopify.analytics.publish('menu_click', data);
      if (result && typeof result.catch === 'function') result.catch(function () {});
    } catch (_) { /* Tracking must never interrupt navigation. */ }
  }, true);
})();
